import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface PrimaryButtonProps {
    onClick?: () => void;
    to?: string;
    children: ReactNode;
    type?: 'button' | 'submit';
    disabled?: boolean;
    className?: string;
}

export default function PrimaryButton({ 
    onClick, 
    to,
    children, 
    type = 'button',
    disabled = false,
    className = ''
}: PrimaryButtonProps) {
    const buttonClasses = `inline-flex items-center justify-center px-6 py-2 
        text-base font-medium rounded-md text-white bg-[#3B6AA0] 
        hover:bg-[#2d5075] transition-colors w-[160px]
        disabled:bg-gray-400 disabled:cursor-not-allowed 
        ${className}`;

    if (to) {
        return (
            <Link to={to} className={buttonClasses}>
                {children}
            </Link>
        );
    }

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={buttonClasses}
        >
            {children}
        </button>
    );
} 